export enum IconType {
    SYS_LIB = 'SysLib',
    SVG = 'svg'
}